import type { AccountBilling } from "@/domain/model/AccountBilling";
import type { AccountManagementService } from "@/domain/port/AccountManagementService";

export class GetAccountBilling {
  constructor(private readonly service: AccountManagementService) {}

  execute(signal?: AbortSignal): Promise<AccountBilling> {
    return this.service.getBilling(signal);
  }
}
